import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const ScheduleIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M19.76 4.501H4.24a.75.75 0 0 0-.74.762v14.476c0 .42.33.762.74.762h15.52a.75.75 0 0 0 .74-.762V5.263a.75.75 0 0 0-.74-.762ZM7.5 3v3M16.5 3v3M3.5 8.501h17"
            />
        </svg>
    </IconWrapper>
)
